export default defineNuxtRouteMiddleware((to, from) => {
  if (from.query.msw === 'true') {
    if (!to.query.msw) {
      return navigateTo({
        path: to.path,
        query: {
          ...to.query,
          msw: 'true'
        }
      });
    }
  }
});
